module.exports = __webpack_public_path__ + "media/images/flags/kg-1fe994c1e99757dce0236378b8704696.svg";